/**
 * Apollo usually resolves rather than throws on GraphQL errors, so a settled
 * promise alone is not proof the preference was saved.
 */
export const didUpdatePreferencePayload = (
  result: { error?: unknown; errors?: unknown },
  payload: unknown
) => !result.error && !result.errors && Boolean(payload);
